import { useUser } from "@/contexts/UserContext";
import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";

export const RequireAdmin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, login, isLoading } = useUser();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (!user) {
      login();
      return;
    }

    if (!user.is_admin) {
      navigate("/", { replace: true });
    }
  }, [user, isLoading, location.pathname, login, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <div>Loading...</div>;
  }

  if (!user.is_admin) {
    return null;
  }

  return <Outlet />;
};
